import Plugin from "../core/plugins";
import { PluginDescription } from "../core/plugins/plugin-description";
import { OpenAIMessage, Parameters } from "../core/chat/types";
import { HARDCODED_VALUES } from "../hardcoded-values";

export interface SystemPromptPluginOptions {
    systemPrompt: string;
}

export class SystemPromptPlugin extends Plugin<SystemPromptPluginOptions> {
    describe(): PluginDescription {
        return {
            id: "system-prompt",
            name: "System Prompt",
            options: [
                // System prompt is now hardcoded - no options needed
            ],
        };
    }

    async preprocessModelInput(messages: OpenAIMessage[], parameters: Parameters): Promise<{ messages: OpenAIMessage[]; parameters: Parameters; }> {
        // Get personality and extreme settings from the plugin context
        const personality = this.context?.getOptions()?.personality || 'chill';
        const extreme = this.context?.getOptions()?.extreme || false;
        
        // Format the settings as "personality-extreme"
        const personalityExtreme = `${personality}-${extreme}`;
        
        const output = [
            {
                role: 'system',
                content: `{}
Current date and time: ${new Date().toLocaleString()}`,
            },
            ...messages,
        ];

        return {
            messages: output,
            parameters,
        };
    }
}